/** @format */

import React from 'react';
import { StoreProvider, createStore } from 'easy-peasy';
import TravelSearch from './components/TravelSearch/TravelSearch';
import TravelsSelect from './components/TravelsSelect/TravelsSelect';
import Contact from './components/Contact/Contact';
import Result from './components/Result/Result';
import './App.scss';
import { Switch, Route, withRouter, BrowserRouter } from 'react-router-dom';
import storeModel from './services/api/StoreModel';
import Header from './components/Header';
import Error from './components/Error';
import Terms from './components/Contact/Terms';
import Payment from './components/Payment/Payment';

const store = createStore(storeModel);
function App() {
	return (
		<StoreProvider store={store}>
			<BrowserRouter basename={process.env.PUBLIC_URL}>
				<Header />
				<Switch>
					<Route path='/' exact component={withRouter(TravelSearch)} />
					<Route path='/TravelsSelect/:id' component={withRouter(TravelsSelect)} />
					<Route path='/contact/:id' component={withRouter(Contact)} />
					<Route path='/payment' component={withRouter(Payment)} />
					<Route path='/Result/:guid?' component={withRouter(Result)} />
					<Route path='/Result' component={withRouter(Result)} />
					<Route path='/Terms' component={withRouter(Terms)} />
					<Route path='/Error' component={withRouter(Error)} />
				</Switch>
			</BrowserRouter>
		</StoreProvider>
	);
}

export default App;
